import ModernApiAdapter from '../adapters/ModernApiAdapter'

class PlannerService {
  constructor () {
    this.modernAdapter = new ModernApiAdapter()
  }

  async load (customer, slug) {
    const result = await this.modernAdapter.load(customer, slug).catch(() => null)

    return {
      customer: result.customer,
      product: result.product,
      viewing_dates: result.viewing_dates,
      waitingListEnabled: true
    }
  }

  async storeViewing (viewingRequest) {
    return this.modernAdapter.store(viewingRequest)
  }

  async storeWaitingListSpot (product, contactDetails, answers) {
    return this.modernAdapter.storeWaitingListSpot(product, contactDetails, answers)
  }
}

export default new PlannerService()
